module.exports = __webpack_public_path__ + "img/playslot888-logo.d97e2ea1.png";